
const BtnGoogle = (div) => {
    document.body.classList.add("googleBtn");
    let divGoogle = document.querySelector('.' + div);
    if (!divGoogle) return;
    window.GoogleSubscribe.drawButton(div);
};

module.exports = {
    BtnGoogle
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/SubscribeWithGoogleHelper.js